const EnableButton = (params) => {
    return (
        (params.data.is_base_route != undefined && params.data.is_base_route == 1) ?
            <><i className='fa fa-check'></i> Enabled</> :
            <><button className='btn btn-warning' style={{ padding: "0px 30px 0px 30px" }} onClick={e => params.onEnableBaseRoute(params)}>Enable</button></>
    )
}
export default EnableButton